/* eslint-disable no-undef */
import { EventsManager, SoundEvents } from "../../abstracts/events/EventsManager";
import { ApocalypseSoundNames } from "../assetsLoader/ApocalypseAssetsNames";

const BACKGROUND_MUSIC: string = `BACKGROUND MUSIC`;

export class ApocalypseSoundDebugger {
    private static soundsMap = new Map<string, boolean>();
    private soundsArray: string[] = Object.values(ApocalypseSoundNames).filter(
        (soundName) => soundName !== ApocalypseSoundNames.MAIN_MUSIC
    );
    private dropdownElementsArray: HTMLDivElement[] = [];

    constructor() {
        this.soundsArray = [BACKGROUND_MUSIC, ...this.soundsArray];
        this.soundsArray.map((sound: string) => ApocalypseSoundDebugger.soundsMap.set(sound, true));

        this.createDropdown();
    }

    public static soundIsEnabled(soundName: string): boolean | undefined {
        if (soundName === ApocalypseSoundNames.MAIN_MUSIC) {
            return ApocalypseSoundDebugger.soundsMap.get(BACKGROUND_MUSIC)!;
        }
        return ApocalypseSoundDebugger.soundsMap.get(soundName)!;
    }

    private createDropdown() {
        const mainContainer = document.createElement(`div`);
        mainContainer.id = `ApocalypseSoundDebugger`;
        mainContainer.style.minWidth = `220px`;
        mainContainer.style.height = `auto`;
        mainContainer.style.position = `absolute`;
        mainContainer.style.color = `white`;
        mainContainer.style.fontSize = `12px`;
        mainContainer.style.border = `2px solid white`;
        mainContainer.style.borderRadius = `10px`;
        mainContainer.style.background = `#00000066`;
        mainContainer.style.top = `35px`;
        mainContainer.style.left = `10px`;

        document.body.appendChild(mainContainer);

        const disableAll = document.createElement(`div`);
        disableAll.id = `disableAllSounds`;
        disableAll.innerHTML = `Disable all`;
        disableAll.dataset.enabled = `false`;
        disableAll.style.borderBottom = `1px solid white`;
        disableAll.style.padding = `5px 10px`;
        disableAll.style.textAlign = `right`;
        disableAll.style.cursor = `pointer`;
        disableAll.addEventListener(`click`, () => {
            const enabled = !(disableAll.dataset.enabled === `true`);
            disableAll.dataset.enabled = enabled.toString();
            disableAll.innerHTML = enabled ? `Enable all` : `Disable all`;

            this.dropdownElementsArray.forEach((element) => {
                element.dataset.enabled = (!enabled).toString();

                const checkSymbolIcon = element.querySelector(`#checkSymbolIcon`) as HTMLDivElement;
                const uncheckSymbolIcon = element.querySelector(
                    `#uncheckSymbolIcon`
                ) as HTMLDivElement;

                checkSymbolIcon.style.display = !enabled ? `block` : `none`;
                uncheckSymbolIcon.style.display = enabled ? `block` : `none`;

                const checkOthersIcon = element.querySelector(
                    `#checkSymbolOthersIcon`
                ) as HTMLDivElement;
                const uncheckOthersIcon = element.querySelector(
                    `#uncheckSymbolOthersIcon`
                ) as HTMLDivElement;

                checkOthersIcon.style.display = `none`;
                uncheckOthersIcon.style.display = `block`;

                const disableOtherContainer = element.querySelector(
                    `#disableOtherSoundsContainer`
                ) as HTMLDivElement;
                disableOtherContainer.dataset.enabled = `false`;

                const soundName: string = element.dataset.value ? element.dataset.value : ``;
                ApocalypseSoundDebugger.soundsMap.set(soundName, !enabled);

                if (soundName === BACKGROUND_MUSIC) {
                    enabled && EventsManager.trigger(SoundEvents.STOP_BACKGROUND_MUSIC);
                    !enabled && EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC);
                } else {
                    enabled && EventsManager.trigger(SoundEvents.STOP_SOUND, { name: soundName });
                }
            });
        });

        mainContainer.appendChild(disableAll);

        const elementsContainer = document.createElement(`div`);
        elementsContainer.id = `elementsContainer`;
        elementsContainer.style.width = `100%`;
        elementsContainer.style.height = `auto`;
        elementsContainer.style.maxHeight = `360px`;
        elementsContainer.style.overflowY = `auto`;

        this.soundsArray.forEach((soundName) => {
            const element = this.createDropdownElement(soundName);
            elementsContainer.appendChild(element);
            this.dropdownElementsArray.push(element);
        });
        mainContainer.appendChild(elementsContainer);
    }

    private createDropdownElement(soundName: string) {
        const element = document.createElement(`div`);
        element.style.position = `relative`;
        element.style.width = `100%`;
        element.style.display = `flex`;
        element.style.padding = `5px 10px`;
        element.style.alignItems = `center`;
        element.style.justifyContent = `space-between`;
        element.style.userSelect = `none`;
        element.style.borderBottom = `1px solid white`;

        let enabled: boolean = true;
        element.dataset.enabled = enabled.toString();
        element.dataset.value = soundName;

        const checkSymbolIcon = document.createElement(`div`);
        checkSymbolIcon.innerHTML = `☑`;
        checkSymbolIcon.id = `checkSymbolIcon`;
        checkSymbolIcon.style.fontSize = `20px`;

        const uncheckSymbolIcon = document.createElement(`div`);
        uncheckSymbolIcon.innerHTML = `☐`;
        uncheckSymbolIcon.id = `uncheckSymbolIcon`;
        uncheckSymbolIcon.style.fontSize = `20px`;
        uncheckSymbolIcon.style.display = `none`;

        const elementText = document.createElement(`div`);
        elementText.innerText = soundName;
        element.appendChild(elementText);

        const soundsControllContainer = document.createElement(`div`);
        soundsControllContainer.style.display = `flex`;
        soundsControllContainer.id = `soundsControllContainer`;

        const disableSoundContainer = document.createElement(`div`);
        disableSoundContainer.id = `disableSoundContainer`;
        disableSoundContainer.style.cursor = `pointer`;
        disableSoundContainer.appendChild(checkSymbolIcon);
        disableSoundContainer.appendChild(uncheckSymbolIcon);
        disableSoundContainer.addEventListener(`click`, () => {
            let disabledCount = 0;
            const enabled = !(element.dataset.enabled === `true`);
            element.dataset.enabled = enabled.toString();

            checkSymbolIcon.style.display = enabled ? `block` : `none`;
            uncheckSymbolIcon.style.display = !enabled ? `block` : `none`;

            ApocalypseSoundDebugger.soundsMap.set(soundName, enabled);
            if (!enabled) {
                disabledCount++;
            }

            const disableOtherContainer = element.querySelector(
                `#disableOtherSoundsContainer`
            ) as HTMLDivElement;
            disableOtherContainer.dataset.enabled = `false`;

            const checkOthersIcon = disableOtherContainer.querySelector(
                `#checkSymbolOthersIcon`
            ) as HTMLDivElement;
            const uncheckOthersIcon = disableOtherContainer.querySelector(
                `#uncheckSymbolOthersIcon`
            ) as HTMLDivElement;

            checkOthersIcon.style.display = `none`;
            uncheckOthersIcon.style.display = `block`;

            if (soundName === BACKGROUND_MUSIC) {
                !enabled && EventsManager.trigger(SoundEvents.STOP_BACKGROUND_MUSIC);
                enabled && EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC);
            } else {
                !enabled && EventsManager.trigger(SoundEvents.STOP_SOUND, { name: soundName });
            }

            const disableAllBtn = document.querySelector(`#disableAllSounds`) as HTMLDivElement;
            disableAllBtn.dataset.enabled = `false`;
            disableAllBtn.innerHTML = `Disable all`;

            this.dropdownElementsArray.forEach((dropdownElement) => {
                if (dropdownElement === element) {
                    return;
                }

                if (!dropdownElement.dataset.disable) {
                    disabledCount++;
                }

                const checkOthersIcon = dropdownElement.querySelector(
                    `#checkSymbolOthersIcon`
                ) as HTMLDivElement;
                const uncheckOthersIcon = dropdownElement.querySelector(
                    `#uncheckSymbolOthersIcon`
                ) as HTMLDivElement;

                checkOthersIcon.style.display = `none`;
                uncheckOthersIcon.style.display = `block`;

                const disableOtherContainer = dropdownElement.querySelector(
                    `#disableOtherSoundsContainer`
                ) as HTMLDivElement;
                disableOtherContainer.dataset.enabled = `false`;

                if (disabledCount === this.dropdownElementsArray.length) {
                    disableOtherContainer.dataset.enabled = `true`;
                    disableAllBtn.innerHTML = `Enable all`;
                    disableAllBtn.dataset.enabled = `true`;
                }
            });
        });

        soundsControllContainer.appendChild(disableSoundContainer);

        const checkSymbolOthersIcon = document.createElement(`div`);
        checkSymbolOthersIcon.innerHTML = `☑`;
        checkSymbolOthersIcon.id = `checkSymbolOthersIcon`;
        checkSymbolOthersIcon.style.fontSize = `20px`;
        checkSymbolOthersIcon.style.display = `none`;

        const uncheckSymbolOthersIcon = document.createElement(`div`);
        uncheckSymbolOthersIcon.innerHTML = `☐`;
        uncheckSymbolOthersIcon.id = `uncheckSymbolOthersIcon`;
        uncheckSymbolOthersIcon.style.fontSize = `20px`;

        const disableOtherSoundsContainer = document.createElement(`div`);
        disableOtherSoundsContainer.id = `disableOtherSoundsContainer`;
        disableOtherSoundsContainer.title = `Disable other sounds`;
        disableOtherSoundsContainer.style.cursor = `pointer`;
        disableOtherSoundsContainer.style.marginLeft = `10px`;
        disableOtherSoundsContainer.dataset.set = `false`;

        disableOtherSoundsContainer.appendChild(checkSymbolOthersIcon);
        disableOtherSoundsContainer.appendChild(uncheckSymbolOthersIcon);

        disableOtherSoundsContainer.addEventListener(`click`, () => {
            const wasPreviouslyEnabled = element.dataset.enabled === `true`;
            if (!wasPreviouslyEnabled) {
                ApocalypseSoundDebugger.soundsMap.set(soundName, true);

                if (soundName === BACKGROUND_MUSIC) {
                    wasPreviouslyEnabled &&
                        EventsManager.trigger(SoundEvents.STOP_BACKGROUND_MUSIC);
                    !wasPreviouslyEnabled &&
                        EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC);
                } else {
                    wasPreviouslyEnabled &&
                        EventsManager.trigger(SoundEvents.STOP_SOUND, { name: soundName });
                }
            }

            const enabled = !(disableOtherSoundsContainer.dataset.enabled === `true`);
            disableOtherSoundsContainer.dataset.enabled = enabled.toString();
            checkSymbolIcon.style.display = `block`;
            uncheckSymbolIcon.style.display = `none`;
            checkSymbolOthersIcon.style.display = enabled ? `block` : `none`;
            uncheckSymbolOthersIcon.style.display = !enabled ? `block` : `none`;

            const disableAllBtn = document.querySelector(`#disableAllSounds`) as HTMLDivElement;
            disableAllBtn.dataset.enabled = `false`;
            disableAllBtn.innerHTML = `Disable all`;

            this.dropdownElementsArray.forEach((dropdownElement) => {
                if (dropdownElement === element) {
                    return;
                }

                dropdownElement.dataset.enabled = (!enabled).toString();

                const checkSymbolIcon = dropdownElement.querySelector(
                    `#checkSymbolIcon`
                ) as HTMLDivElement;
                const uncheckSymbolIcon = dropdownElement.querySelector(
                    `#uncheckSymbolIcon`
                ) as HTMLDivElement;

                checkSymbolIcon.style.display = !enabled ? `block` : `none`;
                uncheckSymbolIcon.style.display = enabled ? `block` : `none`;

                const disableOtherContainer = dropdownElement.querySelector(
                    `#disableOtherSoundsContainer`
                ) as HTMLDivElement;
                disableOtherContainer.dataset.enabled = `false`;

                const checkOthersIcon = dropdownElement.querySelector(
                    `#checkSymbolOthersIcon`
                ) as HTMLDivElement;
                const uncheckOthersIcon = dropdownElement.querySelector(
                    `#uncheckSymbolOthersIcon`
                ) as HTMLDivElement;

                checkOthersIcon.style.display = `none`;
                uncheckOthersIcon.style.display = `block`;

                const soundName: string = dropdownElement.dataset.value
                    ? dropdownElement.dataset.value
                    : ``;
                ApocalypseSoundDebugger.soundsMap.set(soundName, !enabled);

                if (soundName === BACKGROUND_MUSIC) {
                    enabled && EventsManager.trigger(SoundEvents.STOP_BACKGROUND_MUSIC);
                    !enabled && EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC);
                } else {
                    enabled && EventsManager.trigger(SoundEvents.STOP_SOUND, { name: soundName });
                }
            });
        });

        soundsControllContainer.appendChild(disableOtherSoundsContainer);
        element.appendChild(soundsControllContainer);

        return element;
    }
}
